<template>
    <div :class="[
            'border border-[#373737] rounded-full px-2.5 py-1.5 text-xs cursor-pointer',
            {
                'text-gray-400': !props.checked,
                'text-white bg-gray-600 bg-opacity-50': props.checked
            }
        ]"
        :data-e2e="props.dataE2e"
    >
        <slot />
    </div>
</template>

<script lang="ts" setup>
interface Props {
    checked: boolean;
    dataE2e?: string;
}

const props = defineProps<Props>()
</script>